import { rqlBuilder } from '@extrahorizon/javascript-sdk';
import { useQuery } from '@tanstack/react-query';
import { DocumentIdProps } from 'models/general';
import { EmptyParametersError } from 'services/errors/EmptyParametersError';
import { queryKeys, SCHEMA_NAMES, sdk } from 'utils/query';

export const getBloodPressureMeasurementComment = async ({ documentId }: DocumentIdProps) => {
  if (!documentId) throw new EmptyParametersError();

  const { data: comments } = await sdk.data.comments.find(SCHEMA_NAMES.bloodPressureMeasurements, documentId, {
    rql: rqlBuilder().sort('-creationTimestamp').build(),
  });

  return comments.length > 0 ? comments[0].text : '';
};

export const useGetBloodPressureMeasurementComment = (variables: DocumentIdProps) => {
  return useQuery({
    queryKey: [queryKeys.bloodPressureMeasurementComment, variables.documentId],
    queryFn: () => getBloodPressureMeasurementComment(variables),
    enabled: !!variables.documentId,
  });
};
